import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { prop } from 'ramda';

import connect from 'app/libs/connect';
import renderIf from 'app/enhancers/renderIf';
import S from 'app/features/newLanding/components/HeroBlock/UserGreeting/UserGreeting.styled';
import {
  isGreetingLongerThan20Chars,
  isGreetingLongerThan42Chars,
  userGreeting,
} from 'app/features/user/selectors';

const UI = ({
  userGreeting,
  isGreetingLongerThan42Chars,
  isGreetingLongerThan20Chars,
}) => (
  <S.UserGreeting
    data-t="user-greeting"
    isGreetingLongerThan20Chars={isGreetingLongerThan20Chars}
    isGreetingLongerThan42Chars={isGreetingLongerThan42Chars}
  >
    {userGreeting},{' '}
  </S.UserGreeting>
);

UI.propTypes = {
  userGreeting: PropTypes.string.isRequired,
  isGreetingLongerThan42Chars: PropTypes.bool,
  isGreetingLongerThan20Chars: PropTypes.bool,
};

UI.defaultProps = {
  isGreetingLongerThan20Chars: false,
  isGreetingLongerThan42Chars: false,
};

UI.displayName = 'UserGreeting';

const UserGreeting = compose(
  connect({
    userGreeting,
    isGreetingLongerThan42Chars,
    isGreetingLongerThan20Chars,
  }),
  renderIf(prop('userGreeting')),
)(UI);

export { UI };

export default UserGreeting;
